import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { RosterDay } from '../../types';
import { Employee } from './types';
import { Interval, PlanUnit } from 'components/types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';

import { Accordion } from 'components/shared';

import EmployeeRow from './EmployeeRow';

const EmployeeGridStyles = styled.div`
  flex-grow: 1;
  position: relative;
`;

type Props = {
  employees: Employee[];
  isAccordion?: boolean;
  selectedPlanUnits: PlanUnit[];
  rosterDays: RosterDay[];
  portal: string;
  interval: Interval;
};

export default function EmployeeGrid({
  employees,
  isAccordion,
  selectedPlanUnits,
  rosterDays,
  portal,
  interval
}: Props) {
  const { t } = useTranslation('common');
  const children = (
    <Table className="roster-grid">
      <TableBody>
        {sortBy(employees, 'nameInformal').map((employee) => (
          <EmployeeRow
            key={`${employee.benefit.id}_${employee.plannedCostCenter.id}`}
            employee={employee}
            selectedPlanUnits={selectedPlanUnits}
            rosterDays={rosterDays}
            portal={portal}
            interval={interval}
          />
        ))}
      </TableBody>
    </Table>
  );
  if (isAccordion) {
    return (
      <Accordion disableGutters summary={t('employees')} defaultExpanded>
        {children}
      </Accordion>
    );
  }
  return (
    <EmployeeGridStyles className="employees-container">
      <div className="wrap-container">
        <div>{children}</div>
      </div>
    </EmployeeGridStyles>
  );
}
